import React, { useState, useEffect } from 'react';
import {fetchCallScore, fetchJobStatus, getSymblAccessToken, fetchTranscriptMessages, fetchAttendees} from "../../../services/callScore";
import "./humanCallScoreReport.scss"

import CallScoreFactors from './CallWrapUI/CallScoreFactors'
import CallScore from './CallWrapUI/CallScore'
import ProgressBar from '../ProgressBar/ProgressBar'
import HumanCallScoreReportLoader
    from "../HumanCallScore/HumanCallScoreReportLoader/HumanCallScoreReportLoader";
import Transcription from '../../Transcription/Transcription'
import { formatTranscriptMessages } from "../../../utils"

const MEETING_DETAILS_MENU = {
    CALLSCORE: 'callscore_menu',
    TRANSCRIPT: 'transcript_menu'
}

const MENU_ITEMS = [
    {
        key: MEETING_DETAILS_MENU.CALLSCORE,
        name: 'Call Score'
    },
    {
        key: MEETING_DETAILS_MENU.TRANSCRIPT,
        name: 'Transcription'
    }
]

const CallScoreReportContainer = ({ conversationId, jobId, isProcessingAsyncApiRequest, setIsLoading }) => {
    const [jobStatus, setJobStatus] = useState(null);
    console.log('this is jobStatus', jobStatus)
    console.log('this is isProcessingAsyncApiRequest', isProcessingAsyncApiRequest)
    const [selectedMenu, setSelectedMenu] = useState(MEETING_DETAILS_MENU.CALLSCORE);
    const [callScoreResponse, setCallScoreResponse] = useState(null);
    const [transcriptMessages, setTranscriptMessages] = useState([]);
    const [attendeesIdsWithIndex, setAttendeesIdsWithIndex] = useState(null);
    const [loadingData, setLoadingData] = useState(false);
    const [jobStatusError, setJobStatusError] = useState(null);
    const [callScoreError, setCallScoreError] = useState(null);
    
    const [step, setStep] = useState(0);

    useEffect(() => {
        if (isProcessingAsyncApiRequest) {
            setJobStatus('creating_conversation')
        }
    }, [isProcessingAsyncApiRequest])
    
    useEffect(() => {
        if (jobStatus === 'creating_conversation') {
          setStep(0);
        } else if (jobStatus === 'in_progress') {
          setStep(1);
        } else if (jobStatus === 'processing') {
          setStep(2);
        } else if (jobStatus === 'completed') {
          setStep(3);
        }
    }, [jobStatus]);

    console.log('this is transcriptMessages', transcriptMessages)
    useEffect(() => {
        if (!conversationId || !jobId) return;        

        const fetchStatus = async () => {
            try {
                const accessToken = await getSymblAccessToken();
                const statusData = await fetchJobStatus(conversationId);
                setJobStatus(statusData.status);

                if (statusData.status === 'completed') {
                    setLoadingData(true);

                    // Retrieve callscore data
                    const callScoreData = await fetchCallScore(conversationId);
                    
                    // Retrieve transcript messages 
                    const { messages = [] } = await fetchTranscriptMessages(conversationId);
                    const formattedMessages = formatTranscriptMessages(messages)
                    
                    // Retrieve transcript attendees
                    const { members = [] } = await fetchAttendees(conversationId)
                    const membersIdsWithIndex = members?.reduce((attendeeIdsWithIndex,{id},index) => ({...attendeeIdsWithIndex, [id]: index}) , {});

                    setCallScoreResponse(callScoreData);
                    setTranscriptMessages(formattedMessages);
                    setAttendeesIdsWithIndex(membersIdsWithIndex);

                    setLoadingData(false);
                    setIsLoading(false);
                    setJobStatus(null);
                    clearInterval(interval);  // Stop polling when job is completed and call score is fetched
                }
            } catch (error) {
                setJobStatusError(error);
                setJobStatus(null);
                clearInterval(interval);  // Stop polling on error
            }
        };

        fetchStatus();
        const interval = setInterval(fetchStatus, 10000);

        return () => clearInterval(interval);
    }, [conversationId, jobId]);

    const handleMenuClick = (menu) => {
        setSelectedMenu(menu);
    }
    
    if ((!conversationId || !jobId) && jobStatus !== 'creating_conversation') return <div>Please select file and score card to generate call score</div>;

    if (jobStatusError) return <div>Error fetching job status: {jobStatusError.message}</div>;

    if (jobStatus) {
        return (
            <div>
              <ProgressBar step={step} />
              <HumanCallScoreReportLoader />
            </div>
          );        
    }

    if (callScoreError) return <div className={"loading-instruction"}>Error fetching call score: {callScoreError.message}</div>;

    if (callScoreResponse && transcriptMessages) {
        return (
            <div className={"call-score-content"}>
                <div className={"menu-items"} style={{ backgroundColor: 'transparent'}}>
                    {
                        MENU_ITEMS.map(({key, name}) => <div key={key} className={`${selectedMenu === key ? "active-menu-tab" : ""}`} onClick={() => handleMenuClick(key)}>
                            <p>{name}</p>
                            <div className={"highlight"}></div>
                        </div>)
                    }
                </div>
                {
                    selectedMenu === MEETING_DETAILS_MENU.CALLSCORE
                    ? <>
                        <p className={"call-score-summary"}>{callScoreResponse?.summary}</p>
                        <CallScore callScore={callScoreResponse?.score} factors={callScoreResponse?.criteria} showColoredBackground={true} />
                        <CallScoreFactors factors={callScoreResponse?.criteria}/>
                    </>
                    : <Transcription messages={transcriptMessages} attendeesIdsWithIndex={attendeesIdsWithIndex} showAutoScroll={false} />
                }
            </div>
        )
    }

    return null;
};

export default CallScoreReportContainer;
